const API_BASE_URL = process.env.REACT_APP_AUDIT_API_URL;

const getReportQuestionaryAsPdf = async (
  questionaryId: number
): Promise<Blob> => {
  const url = `${API_BASE_URL}/reports/questionary/pdf/${questionaryId}`;
  const response = await fetch(url);

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(
      `Error del servidor (${response.status}): ${
        errorText || "No se pudo generar el PDF."
      }`
    );
  }

  return response.blob();
};

const getReportQuestionaryAsExcel = async (
  questionaryId: number
): Promise<Blob> => {
  const url = `${API_BASE_URL}/reports/questionary/excel/${questionaryId}`;
  const response = await fetch(url);

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(
      `Error del servidor (${response.status}): ${
        errorText || "No se pudo generar el archivo Excel."
      }`
    );
  }

  return response.blob();
};

const getReportAuditAsPdf = async (auditId: number): Promise<Blob> => {
  const url = `${API_BASE_URL}/reports/audit/pdf/${auditId}`;
  const response = await fetch(url);

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(
      `Error del servidor (${response.status}): ${
        errorText || "No se pudo generar el PDF."
      }`
    );
  }

  return response.blob();
};

const getReportAuditAsExcel = async (auditId: number): Promise<Blob> => {
  const url = `${API_BASE_URL}/reports/audit/excel/${auditId}`;
  const response = await fetch(url);

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(
      `Error del servidor (${response.status}): ${
        errorText || "No se pudo generar el archivo Excel."
      }`
    );
  }

  return response.blob();
};

const ReportService = {
  getReportQuestionaryAsPdf,
  getReportQuestionaryAsExcel,
  getReportAuditAsPdf,
  getReportAuditAsExcel,
};

export default ReportService;
